import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../../services/api";
import "./library.css";

export default function LibraryDashboard() {
  const school   = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [stats, setStats] = useState({
    total_books: 0, total_copies: 0,
    issued_books: 0, overdue_books: 0,
  });

  const loadStats = async () => {
    try {
      const res = await API.get("/school-admin/library/dashboard/", {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setStats(res.data);
    } catch (err) { console.error(err); }
  };

  useEffect(() => { loadStats(); }, []);

  const cards = [
    { key:"books",   icon:"📚", label:"Total Books",   value: stats.total_books,  nav:"/school-admin/library/books" },
    { key:"copies",  icon:"🗂",  label:"Total Copies",  value: stats.total_copies, nav:"/school-admin/library/books" },
    { key:"issued",  icon:"📤", label:"Issued Books",  value: stats.issued_books, nav:"/school-admin/library/return" },
    { key:"overdue", icon:"⚠️", label:"Overdue",       value: stats.overdue_books,nav:"/school-admin/library/return" },
  ];

  return (
    <div className="lb-page">

      {/* ══ HERO ══ */}
      <div className="lb-hero">
        <div className="lb-hero-left">
          <div className="lb-hero-icon">📖</div>
          <div>
            <h2 className="lb-hero-title">Library Dashboard</h2>
            <p className="lb-hero-sub">Manage books, copies, issues and returns</p>
          </div>
        </div>
        <div className="lb-hero-right">
          <button className="lb-btn-back" onClick={() => navigate("/school-admin/library/categories")}>
            🗂 Categories
          </button>
          <button className="lb-btn-add" onClick={() => navigate("/school-admin/library/books")}>
            📚 All Books
          </button>
        </div>
      </div>

      {/* ══ STAT CARDS ══ */}
      <div className="lb-stat-grid">
        {cards.map(c => (
          <div
            key={c.key}
            className={`lb-stat ${c.key}`}
            style={{ cursor:"pointer" }}
            onClick={() => navigate(c.nav)}
          >
            <span className="lb-stat-icon">{c.icon}</span>
            <p className="lb-stat-label">{c.label}</p>
            <p className="lb-stat-value">{c.value}</p>
          </div>
        ))}
      </div>

      {/* ══ QUICK ACTIONS ══ */}
      <div className="lb-card" style={{ padding:"24px 28px" }}>
        <p style={{ fontSize:"11px", fontWeight:800, color:"#94a3b8", textTransform:"uppercase", letterSpacing:".06em", marginBottom:"18px", paddingBottom:"12px", borderBottom:"1.5px solid #f1f5f9" }}>
          Quick Actions
        </p>
        <div style={{ display:"flex", flexWrap:"wrap", gap:"12px" }}>
          {[
            { label:"📚 Books",       path:"/school-admin/library/books" },
            { label:"➕ Add Book",    path:"/school-admin/library/books/add" },
            { label:"📤 Issue Book",  path:"/school-admin/library/issue" },
            { label:"↩ Return Book", path:"/school-admin/library/return" },
            { label:"🗂 Categories",  path:"/school-admin/library/categories" },
          ].map(a => (
            <button
              key={a.path}
              onClick={() => navigate(a.path)}
              style={{
                padding:"10px 18px", borderRadius:"10px", border:"1.5px solid #bfdbfe",
                background:"#eff6ff", color:"#1e40af", fontWeight:700, fontSize:"13px",
                cursor:"pointer", transition:".2s",
              }}
              onMouseOver={e => { e.currentTarget.style.background="#dbeafe"; e.currentTarget.style.transform="translateY(-1px)"; }}
              onMouseOut={e => { e.currentTarget.style.background="#eff6ff"; e.currentTarget.style.transform=""; }}
            >
              {a.label}
            </button>
          ))}
        </div>
      </div>

    </div>
  );
}
